import request from "@/utils/request"

// 统计
export function statistics(interval, timeType) {
  return request({
    url: "/index/user/buy/deviceNumber",
    method: "POST",
    data: {
      interval,
      timeType
    }
  })
}
//首页-销售统计（6）
export function findIndexDeviceTab() {
  return request({
    url: "/index/user/findIndexDeviceTab",
    method: "POST",
    data: {
    }
  })
}
//首页-等级统计（6）
export function findIndexLevel() {
  return request({
    url: "/index/user/findIndexLevel",
    method: "POST",
    data: {
    }
  })
}

// 购买记录
export function PurchaseHistory(pageIndex, pageSize=20, userName) {
  return request({
    url: "/index/user/buyRecord",
    method: "POST",
    data: {
      pageIndex,
      pageSize,
      userName
    }
  })
}
// 日志记录
export function LogHistory(page, pageSize=10, userName) {
  return request({
    url: "/logAdminAgent/findLogAdminAgentPage",
    method: "POST",
    data: {
      page,
      pageSize,
      userName
    }
  })
}
